
import { mapActions, mapMutations, mapState } from "vuex";
import Previewer from 'vux/src/components/previewer/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import bCard from "bootstrap-vue/es/components/card/card";
import bTabs from "bootstrap-vue/es/components/tabs/tabs";
import bTab from "bootstrap-vue/es/components/tabs/tab";
import url from "url";
import _ from "lodash";
import moment from "moment";
import bone from "../assets/javascripts/bone";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import wx from "weixin-js-sdk";
import Qrcode from "vux/src/components/qrcode/index";
import { postureReport} from "../assets/lang.conf/root";
let navList = [
{
text: "正面",
bulletClassName: "pagination-bullet bone_front",
containerClassName: "",
iconClassName: "pagination-icon pagination-face"
},
{
text: "侧面",
bulletClassName: "pagination-bullet",
containerClassName: "",
iconClassName: "pagination-icon pagination-side"
},
{
text: "背面",
bulletClassName: "pagination-bullet bone_back",
containerClassName: "hidden-pagination",
iconClassName: ""
}
];

export default {
name: "Posture_report",
i18n: {

messages: {
...postureReport
}
},
directive: {
bModalDirective
},
props: ["updateSwiper"],
components: {
Qrcode,
swiper,
swiperSlide,
Previewer,
Loading,
bModal,
bTabs,
bTab,
bCard
},
data() {
return {
boneDescription: this.$t("boneDescription"),
descripName: this.$t("descripName"),
details: this.$t("details"),
navList: [
{
text: this.$tc("navList", 0),
bulletClassName: "pagination-bullet bone_front",
containerClassName: "",
iconClassName: "pagination-icon pagination-face"
},
{
text: this.$tc("navList", 1),
bulletClassName: "pagination-bullet",
containerClassName: "",
iconClassName: "pagination-icon pagination-side"
},
{
text: this.$tc("navList", 2),
bulletClassName: "pagination-bullet bone_back",
containerClassName: "hidden-pagination",
iconClassName: ""
}
],
bodyPart: bone.bodyPart,
boneIndex: 0,
shelter: false,
valid: true,
loading: true,
reportData: {},
customer: {},
cur_index: window.cur_index,
swiperOptions: {
pagination: {
el: ".postureS-swiper-pagination",
clickable: true,
renderBullet(index, className) {
let textAlign = "content-align-center";

let bone_front = "",
bone_back = "";
if (
/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
navigator.userAgent
)
) {
if (index == 0 || index == 2) {
textAlign = "";
}
}
let style = "";
if (index == 1) {
style = 'style="width: 208px;"';
}

return (
`<div style="position: relative" ` +
style +
` class="bone` +
index +
` content-row content-row-column ` +
textAlign +
` ${className}">` +
`<div style="height:14px"></div>` +
`<span style="font-size:.9rem !important;"  class="${
navList[index].bulletClassName
}">${navList[index].text}</span>` +
`<div style="height:0.12rem;margin-top: 3px;" class="boneBar boneBar` +
index +
`"></div>` +
`</div>`
);
}
},
allowTouchMove: true,
autoplay: false,
on: {
init: () => {
this.drawBone(0);
},
slidePrevTransitionStart: function() {},
slideNextTransitionStart: function() {},
transitionEnd: function() {
localStorage.setItem("bone_index", this.activeIndex);
console.log("bone:", this.activeIndex);
},
touchEnd: () => {},
slideChangeTransitionEnd: () => {
let boneIndex = localStorage.getItem("bone_index");
this.boneIndex = boneIndex;
console.log("boneIndex:", boneIndex);
},
click: function() {},
slideChange: () => {
this.drawBone(0);
this.drawBone(1);
this.drawBone(2);
}
}
},
normalRisks: [],
mildRisks: [],
severeRisks: [],
level: {
normal: "normal",
mild: "mild",
severe: "severe"
},
risks: {},
points: null,
photos: null,
coverInfo: {},
modalInfo: null,
canvas: null,
img: {
face: null,
side: null
},
isWechat: false,
uuid: "",
type: "",
showMini: false,
drawFinish: {
face: false,
back: false,
side: false
}
};
},
computed: {},
watch: {
updateSwiper: function() {
this.slideIn();
this.$emit("updateSwiper", false);
}
},
methods: {
stop: function() {},
start: function() {},
slideIn() {
this.$refs.postureBoneSwiper.swiper.slideTo(0);
},
drawBone(idx) {
let data = this.reportData;

if (idx === 0) {
if (this.drawFinish.face === false) {
bone.drawFrontBone(data, document.getElementById("faceBone"));
this.drawFinish.face = true;
}
} else if (idx === 1) {
if (this.drawFinish.side === false) {
bone.drawSideBone(data, document.getElementById("sideBone"));
this.drawFinish.side = true;
}
} else if (idx === 2) {
if (this.drawFinish.back === false) {
bone.drawBackBone(data, document.getElementById("backBone"));
this.drawFinish.back = true;
}
}
},

sortHighToLow(arr) {
return _.orderBy(arr, ["value"], ["desc"]);
},
initBone() {
let data = this.reportData;
this.$nextTick(function() {
bone.drawFrontBone(data, document.getElementById("faceBone"));
bone.drawSideBone(data, document.getElementById("sideBone"));
bone.drawBackBone(data, document.getElementById("backBone"));
});
},
...mapState({
initReportData(state) {
let reportData = state.vux.reportData;
let _this = this;
if (_.isNull(reportData)) {
let uuid = "";
let type = "";

let urlquery = url.parse(window.location.href).query;
let query = urlquery.split("&");
for (let every = 0; every < query.length; every++) {
if (query[every].indexOf("uuid=") !== -1) {
uuid = query[every].replace("uuid=", "");
}
if (query[every].indexOf("type=") !== -1) {
type = query[every].replace("type=", "");
}
}
this.uuid = uuid;
this.type = type;
this.get({
url: `v1/posture/reports/${uuid}`,
params: {
type: type
},
success(result) {
_this.updateReportData({
reportData: result
});
_this.getReportData();
},
error(data) {
_this.loading = false;
_this.valid = false;
}
});
} else {
_this.getReportData();
}
},
getReportData(state) {
this.loading = false;
let reportData = state.vux.reportData;
let that = this;
wx.miniProgram.getEnv(res => {

if (res.miniprogram) {
that.isWechat = true;
} else {
that.isWechat = false;
}
});

this.qrImage = reportData.solutions;

let customer = reportData.customer;
let header = reportData.header;
let user = reportData.user;
let coverInfo = {};
if (_.isNull(header)) {
coverInfo.date = "--";
coverInfo.time = "--";
} else {
coverInfo.date = moment(header.creationTime).format("YYYY-MM-DD");
coverInfo.time = moment(header.creationTime).format("hh:mm");
}

if (_.isNull(user)) {
coverInfo.userName = "--";
} else {
coverInfo.userName = user.name;
}

if (_.isNull(customer)) {
coverInfo.customerName = "--";
} else {
coverInfo.customerName = customer.name;
}

this.coverInfo = coverInfo;


this.conclusion = reportData.conclusion;
let conclusion = this.conclusion;





































let points = {
face: conclusion.face.points,
side: Object.assign(conclusion.side.points, {
side: conclusion.side.side
})
};
this.points = points;


let photos = {
face: reportData.face,
side: reportData.side
};
this.photos = photos;
this.reportData = reportData;


}
}),
...mapActions(["get"]),
...mapMutations(["updateReportData"])
},
created() {
bone.init(this.descripName, this.boneDescription, this.details);
this.initReportData();
console.log(" this.reportData:", bone);
for (var i = 0; i < navList.length; i++) {
navList[i].text = this.navList[i].text;
}
}
};



// WEBPACK FOOTER //
// ./src/components/Posture_report.vue